import { combineReducers } from "redux";

export const types = {
  SET_MAJOR_LIMIT_FILTER_ID: "SCHOOL_FILTER/SET_MAJOR_LIMIT_FILTER_ID",
  SET_MAJOR_LEVEL_FILTER_ID: "SCHOOL_FILTER/SET_MAJOR_LEVEL_FILTER_ID",
  SET_MAJOR_TAG_FILTER_ID: "SCHOOL_FILTER/SET_MAJOR_TAG_FILTER_ID",
  SET_MAJOR_PROPERTY_FILTER_ID: "SCHOOL_FILTER/SET_MAJOR_PROPERTY_FILTER_ID",
  SET_MAJOR_PROVINCE_FILTER_ID: "SCHOOL_FILTER/SET_MAJOR_PROVINCE_FILTER_ID",

  SET_MAJOR_LIMIT_MARK_ARRAY: "SCHOOL_FILTER/SET_MAJOR_LIMIT_MARK_ARRAY",
  SET_MAJOR_LEVEL_MARK_ARRAY: "SCHOOL_FILTER/SET_MAJOR_LEVEL_MARK_ARRAY",
  SET_MAJOR_TAG_MARK_ARRAY: "SCHOOL_FILTER/SET_MAJOR_TAG_MARK_ARRAY",
  SET_MAJOR_PROPERTY_MARK_ARRAY: "SCHOOL_FILTER/SET_MAJOR_PROPERTY_MARK_ARRAY",
  SET_MAJOR_PROVINCE_MARK_ARRAY: "SCHOOL_FILTER/SET_MAJOR_PROVINCE_MARK_ARRAY",
};

const initialState = {
  schoolFilter: {
    limitFilterId: [],
    levelFilterId: [],
    tagFilterId: [],
    propertyFilterId: [],
    provinceFilterId: [],
  },
  markArray: {
    limitMarkArray: [0, 0, 0, 0],
    levelMarkArray: [0, 0],
    tagMarkArray: [0, 0, 0],
    propertyMarkArray: [0, 0, 0, 0],
    provinceMarkArray: [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
    ],
  },
};

export const actions = {
  //设置选科限制过滤数据
  setLimitFilterId: (limitFilterId) => {
    return {
      type: types.SET_MAJOR_LIMIT_FILTER_ID,
      limitFilterId,
    };
  },
  //设置高校级别过滤数据
  setLevelFilterId: (levelFilterId) => {
    return {
      type: types.SET_MAJOR_LEVEL_FILTER_ID,
      levelFilterId,
    };
  },
  //设置高校标签过滤数据
  setTagFilterId: (tagFilterId) => {
    return {
      type: types.SET_MAJOR_TAG_FILTER_ID,
      tagFilterId,
    };
  },
  //设置办学性质过滤数据
  setPropertyFilterId: (propertyFilterId) => {
    return {
      type: types.SET_MAJOR_PROPERTY_FILTER_ID,
      propertyFilterId,
    };
  },
  //设置地区省份过滤数据
  setProvinceFilterId: (provinceFilterId) => {
    return {
      type: types.SET_MAJOR_PROVINCE_FILTER_ID,
      provinceFilterId,
    };
  },

  //设置选科限制选中标识
  setLimitMarkArray: (limitMarkArray) => {
    return {
      type: types.SET_MAJOR_LIMIT_MARK_ARRAY,
      limitMarkArray,
    };
  },
  //设置高校层次选中标识
  setLevelMarkArray: (levelMarkArray) => {
    return {
      type: types.SET_MAJOR_LEVEL_MARK_ARRAY,
      levelMarkArray,
    };
  },
  //设置高校标签选中标识
  setTagMarkArray: (tagMarkArray) => {
    return {
      type: types.SET_MAJOR_TAG_MARK_ARRAY,
      tagMarkArray,
    };
  },
  //设置办学性质选中标识
  setPropertyMarkArray: (propertyMarkArray) => {
    return {
      type: types.SET_MAJOR_PROPERTY_MARK_ARRAY,
      propertyMarkArray,
    };
  },
  //设置地区选中标识
  setProvinceMarkArray: (provinceMarkArray) => {
    return {
      type: types.SET_MAJOR_PROVINCE_MARK_ARRAY,
      provinceMarkArray,
    };
  },
};

//院校筛选的数据
const schoolFilterData = (state = initialState.schoolFilter, action) => {
  switch (action.type) {
    case types.SET_MAJOR_LIMIT_FILTER_ID:
      return { ...state, limitFilterId: action.limitFilterId };
    case types.SET_MAJOR_LEVEL_FILTER_ID:
      return { ...state, levelFilterId: action.levelFilterId };
    case types.SET_MAJOR_TAG_FILTER_ID:
      return { ...state, tagFilterId: action.tagFilterId };
    case types.SET_MAJOR_PROPERTY_FILTER_ID:
      return { ...state, propertyFilterId: action.propertyFilterId };
    case types.SET_MAJOR_PROVINCE_FILTER_ID:
      return { ...state, provinceFilterId: action.provinceFilterId };
    default:
      return { ...state };
  }
};

//院校筛选中标识的数据
const schoolMarkArrayData = (state = initialState.markArray, action) => {
  switch (action.type) {
    case types.SET_MAJOR_LIMIT_MARK_ARRAY:
      return { ...state, limitMarkArray: action.limitMarkArray };
    case types.SET_MAJOR_LEVEL_MARK_ARRAY:
      return { ...state, levelMarkArray: action.levelMarkArray };
    case types.SET_MAJOR_TAG_MARK_ARRAY:
      return { ...state, tagMarkArray: action.tagMarkArray };
    case types.SET_MAJOR_PROPERTY_MARK_ARRAY:
      return { ...state, propertyMarkArray: action.propertyMarkArray };
    case types.SET_MAJOR_PROVINCE_MARK_ARRAY:
      return { ...state, provinceMarkArray: action.provinceMarkArray };
    default:
      return { ...state };
  }
};

const reducer = combineReducers({
  schoolFilterData,
  schoolMarkArrayData,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/major2schoolfilter.js